module.exports = __webpack_public_path__ + "media/bullet.af5938b7.mp3";